import React, { useEffect, useState } from "react";
import { View, ScrollView } from "react-native";
import { Text, StyledModal, StyledModalHandle, Title, Card } from "@constants/Themed";
import Markdown from "react-native-markdown-display";
import { rules } from "@utils/stringUtils/markDownRules";
import AnimatedLottieView from '@utils/lottieAnimation';
import { useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { DefaultRootState } from "@reduxLocal/persistState";
import { HIDE_UPDATE_MODAL } from "@reduxLocal/actions/types";
import ChangeLogFetcher from "@navigation/logFetch";
import axios from "axios";
import TutorialVideoListWeb from "@navigation/screens/MidLevel/WelcomeScreen/Components/SubComponents/TutorialVideoList.web";

const UpdateMessageModal = ({ hasUpdatePending, callback }: { hasUpdatePending: boolean, callback: () => void }) => {
  const updateModal = useSelector((state: DefaultRootState) => state.modals.updateModal.modalDisplayed);
  const modalRef = React.useRef<StyledModalHandle>(null);
  ChangeLogFetcher();
  const queryClient = useQueryClient();
  const changeLogData = queryClient.getQueryData(['changeLogData']);
  const dispatch = useDispatch();
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const cachedVideos = localStorage.getItem('cachedVideos');
        const cachedTime = localStorage.getItem('cachedTime');
        const oneHour = 60 * 60 * 1000;

        if (cachedVideos && cachedTime && new Date().getTime() - new Date(cachedTime).getTime() < oneHour) {
          setVideos(JSON.parse(cachedVideos));
        } else {
          const response = await axios.get(
            `https://www.googleapis.com/youtube/v3/search?channelId=UCRdoc5WymbTQNNDadRMSYjA&part=snippet&type=video&key=AIzaSyDuBJuGlNDHeG0br1IrJR79OqhEXM_pfCo`
          );
          const videoItems = response.data.items;
          setVideos(videoItems);
          localStorage.setItem('cachedVideos', JSON.stringify(videoItems));
          localStorage.setItem('cachedTime', new Date().toString());
        }
      } catch (error) {
        console.error("Failed to fetch youtube videos", error);
      }
    };

    fetchVideos();
  }, []);

  useEffect(() => {
    hasUpdatePending && modalRef.current?.openModal();
    console.log(updateModal, 'updateModal');
    if (updateModal) {
      modalRef.current?.openModal?.();
    }
  }, [updateModal])

  
  return (
    <StyledModal title="SmartSaaS ChangeLog" caption="Keep up to date with changes and new features" onModalHide={() => {
      callback?.();
      dispatch({ type: HIDE_UPDATE_MODAL })
    }} ref={modalRef} customContent={(
      <View style={{ flex: 1, gap: 30, overflow:"hidden" }}>
        <AnimatedLottieView autoPlay style={{ flex: 1, width: "100%", height: 150, maxHeight: "25%" }} source={require("@assets/animations/landing_Animation_light.json")} />
        <View style={{ flex: 4, height: 600, gap: 10 }}>
          <Title style={{ height: 40, textAlign: "center", color: "white" }}>Latest update Ahoy!</Title>
          <Text style={{ color: "white", textAlign: "center" }}>We've updated the app with some more features, just for you!</Text>
          <Text style={{ textAlign: "center", color: "white" }}>As always, don't be afraid to reach out for new feature requests, as we love hearing from our users.</Text>
        </View>
        {/* <Card style={{ maxHeight: 300, width: 400 }}>
          <TutorialVideoListWeb videoList={videos} />
        </Card> */}
      </View>
    )}>
      <ScrollView style={{ flex: 1, maxWidth: 700, marginVertical: 60 }} contentContainerStyle={{ paddingRight: 20 }}>
        {
          changeLogData &&
          <Markdown rules={rules}>{changeLogData?.toString?.()}</Markdown>
        }
      </ScrollView>
    </StyledModal>
  )
}
export default UpdateMessageModal;